window.dataLayer = window.dataLayer || [];

var googleAnalytics = {
    trackEvent: function (event) {
        window.dataLayer.push(event);
    }
};

export default googleAnalytics;